import React from "react";
import { LuMail, LuPhone, LuMapPin, LuFacebook, LuLinkedin } from "react-icons/lu";
import MarketingLayout from "../components/site/MarketingLayout";
import ContactForm from "../components/site/ContactForm";
import Reveal from "../components/site/Reveal";

const Contact = () => {
  return (
    <MarketingLayout>
      <section className="sv-section">
        <div className="sv-container">
          <Reveal>
            <div className="sv-section-head">
              <h1 className="sv-h1">
                <span className="sv-navy">Contact</span> us
              </h1>
            </div>
          </Reveal>

          <Reveal delayClass="sv-d2">
            <div className="sv-contact">
              <div className="sv-contact__info">
                <h2 className="sv-h2">
                  Let's Create a Healthier Tomorrow Together
                </h2>
                <p className="sv-body">
                  Your health and well-being are our top priorities. Whether you
                  have questions, need support or want to learn more about how
                  our innovative solutions can make a difference, we're here for
                  you.
                </p>

                <div className="sv-contact__row">
                  <LuMail size={18} />
                  <span>tech@svasth.ai</span>
                </div>
                <div className="sv-contact__row">
                  <LuPhone size={18} />
                  <span>+91 960 006 8315</span>
                </div>
                <div className="sv-contact__row">
                  <LuMapPin size={18} />
                  <span>
                    New No. 7C, Perumal Koil Street,
                    <br />
                    Nerkundram, Chennai,
                    <br />
                    Tamil Nadu 600107
                  </span>
                </div>

                <div className="sv-footer__social">
                  <a
                    href="https://www.facebook.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Facebook"
                    className="sv-icon-btn"
                  >
                    <LuFacebook size={18} />
                  </a>
                  <a
                    href="https://www.linkedin.com/company/alegion-health-tech-pvt-ltd/"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="LinkedIn"
                    className="sv-icon-btn"
                  >
                    <LuLinkedin size={18} />
                  </a>
                </div>
              </div>

              <div className="sv-contact__form">
                <ContactForm />
              </div>
            </div>
          </Reveal>
        </div>
      </section>
    </MarketingLayout>
  );
};

export default Contact;
